// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DownPaymentCell-base__GoYjD{display:flex;gap:var(--size-1_5);align-items:center;justify-content:flex-start;width:var(--size-full);height:var(--size-12);padding:var(--size-0) var(--size-4);border-bottom:var(--size-px) solid var(--gray-a3);font:var(--font-body-400-compact);font-feature-settings:var(--feature-settings-body-400-compact);letter-spacing:var(--letter-spacing-body-400-compact)}.DownPaymentCell-not-required__W1wDu{color:var(--text-placeholder)}.DownPaymentCell-paid__admeu{color:var(--text-success)}.DownPaymentCell-partially-paid__LIgC0{color:var(--text-warning)}.DownPaymentCell-unpaid__l02NL{color:var(--text-error)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "DownPaymentCell-base__GoYjD",
	"not-required": "DownPaymentCell-not-required__W1wDu",
	"notRequired": "DownPaymentCell-not-required__W1wDu",
	"paid": "DownPaymentCell-paid__admeu",
	"partially-paid": "DownPaymentCell-partially-paid__LIgC0",
	"partiallyPaid": "DownPaymentCell-partially-paid__LIgC0",
	"unpaid": "DownPaymentCell-unpaid__l02NL"
};
export default ___CSS_LOADER_EXPORT___;
